export default __webpack_public_path__ + "static/media/img_5.576b025f.jpg";